import { RouteRecordRaw, createRouter, createWebHashHistory, createWebHistory } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/index',
  },
  {
    path: '/index',
    component: () => import('@/views/index/index.vue'),
    name: 'index',
    // meta: {
    //   title: '首页'
    // }
  },
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    name: 'webLogin',
    meta: {
      title: '登录'
    }
  },
  {
    path: '/profile/:id',
    name:'profile',
    component: () => import('@/views/profile/index.vue'),
  },
  {
    path: '/regis/:type',
    name:'regis',
    component: () => import('@/views/regis/index.vue'),
  },
  {
    path: '/404',
    component: () => import('@/views/container/404.vue'),
    name: '404',
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
  },
];

const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(import.meta.env.VITE_PUBLIC_PATH),
  routes,
});


// 全局前置守卫，用于设置页面标题
router.beforeEach((to, from, next) => {
  // 如果路由对象中有标题属性，则设置文档标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + '-' + import.meta.env.VITE_APP_TITLE
  }
  next() // 必须调用 next() 来 resolve 这个钩子
})

export default router;
